import { useEffect, useState } from 'react';
import { useAppSelector } from '@store';
import { ChannelStatus, Message as MessageProps } from '../hoc/types';
import NewMessage from './new-message';
import InProgressMessage from './in-progress-message';
import CompletedMessage from './completed-message';
import { MessageTypes } from './types';

const Message = ({
  messages,
  path,
  setAssignPanelIsOpen,
  getEmployees,
  messageId,
  scrollWrapperRef,
  scrollRef,
  getNextMessages,
  pagination,
  setCurrentScrollTop,
  prevMessageIsFetching,
  messagesIsFetching,
  setTopUpFilesSidepanelIsOpen,
  onAddFile,
  accounts,
  sendMessage,
  type,
  changeChatStatusInProgress,
  onReopen,
}: MessageTypes) => {
  const [unreadMessages, setUnreadMessages] = useState<MessageProps[]>([]);

  const {
    messages: {
      general: { selectedChannel },
    },
  } = useAppSelector((state) => state);

  useEffect(() => {
    if (messages && messages.length) {
      const unreadedMessages = messages?.filter((item) => !item.readAt);

      if (unreadedMessages?.length > 0) {
        setUnreadMessages(unreadedMessages);
      }
    }
  }, [messages]);

  let content = <div />;

  if (!selectedChannel?.employeeId && unreadMessages.length) {
    content = (
      <NewMessage
        messages={messages}
        path={path}
        setAssignPanelIsOpen={setAssignPanelIsOpen}
        userName={
          selectedChannel?.user?.profile?.firstName
            ? `${selectedChannel?.user?.profile?.firstName} ${selectedChannel?.user?.profile?.lastName}`
            : selectedChannel?.user?.phone
        }
        getEmployees={() => getEmployees()}
        messageId={messageId}
        createdDate={selectedChannel?.createdAt}
      />
    );
  } else if (
    selectedChannel?.employeeId &&
    selectedChannel?.status !== ChannelStatus.CLOSED
  ) {
    content = (
      <InProgressMessage
        messages={messages as MessageProps[]}
        setTopUpFilesSidepanelIsOpen={setTopUpFilesSidepanelIsOpen}
        messageId={messageId}
        scrollWrapperRef={scrollWrapperRef}
        getNextMessages={getNextMessages}
        pagination={pagination}
        messagesIsFetching={messagesIsFetching}
        scrollRef={scrollRef}
        prevMessageIsFetching={prevMessageIsFetching}
        setCurrentScrollTop={setCurrentScrollTop}
        onAddFile={onAddFile}
        accounts={accounts}
        sendMessage={sendMessage}
        chatCreatedDate={selectedChannel?.createdAt}
        type={type}
      />
    );
  } else if (
    (!selectedChannel?.employeeId && !unreadMessages.length) ||
    selectedChannel?.status === ChannelStatus.CLOSED
  ) {
    content = (
      <CompletedMessage
        path={path}
        messages={messages}
        status={selectedChannel?.status}
        setAssignPanelIsOpen={setAssignPanelIsOpen}
        getEmployees={() => getEmployees()}
        messageId={messageId}
        scrollWrapperRef={scrollWrapperRef}
        getNextMessages={getNextMessages}
        pagination={pagination}
        messagesIsFetching={messagesIsFetching}
        prevMessageIsFetching={prevMessageIsFetching}
        scrollRef={scrollRef}
        setCurrentScrollTop={setCurrentScrollTop}
        changeChatStatusInProgress={changeChatStatusInProgress}
        channelType={selectedChannel?.channelType}
        onReopen={onReopen}
      />
    );
  }

  return content;
};

export default Message;
